import apiClient from "./axios.config";
import Cookies from "js-cookie";
const ownerRegister = {
  register: async (ownerData) => {
    try {
      const response = await apiClient.post("/owner/register", ownerData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  otpVerify: async (ownerData) => {
    try {
      const { custGuid, otp } = ownerData;
      const response = await apiClient.post(
        `/owner/verify-otp?custGuid=${custGuid}&otp=${otp}`
      );

      const accessToken = response?.data?.result?.accessToken;
      const role = response?.data?.result?.role;

      if (accessToken) {
        Cookies.set("accessToken", accessToken, { expires: 7 });
      }

      if (role) {
        Cookies.set("userRole", role, { expires: 7 }); // ✅ Save role as cookie
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  resendOtp: async (ownerData) => {
    try {
      const { custGuid } = ownerData;
      const response = await apiClient.post(
        `/owner/resend-otp?custGuid=${custGuid}`
      );
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default ownerRegister;
